import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/var/www/ao-stom/data/www/ao-stom.ru-nuxt/layouts/default.vue").then(m => m.default || m))
}